// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Lu6","content":"styles_content__n8gg2"};